mutation ReAssignDocument(
  $documentId: ID!
  $data: CustomerWhereByEmailOrEncodedPublicIdInput!
) {
  reAssignDocument(data: $data, where: { id: $documentId }) {
    ...Document
  }
}
